module.exports = __webpack_public_path__ + "media/images/emblems/Mettembert-0181d2d305107f4110bf8ab2455122cb.png";